import { render, staticRenderFns } from "./call-center-user-status-card.vue?vue&type=template&id=29704ac8&scoped=true"
import script from "./call-center-user-status-card.vue?vue&type=script&lang=ts"
export * from "./call-center-user-status-card.vue?vue&type=script&lang=ts"
import style0 from "./call-center-user-status-card.vue?vue&type=style&index=0&id=29704ac8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29704ac8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VIcon,VListItem,VListItemContent,VSpacer})
